export enum TileSize {
    sm,
    lg,
    full,
}

export enum ContactMethod {
    Phone = 1437,
    Email = 1438,
    Text = 1439,
}

export enum ContactDay {
    Mon = 1,
    Tues = 2,
    Wed = 3,
    Thurs = 4,
    Fri = 5,
}

export enum ContactTime {
    Mornings = 1,
    Afternoons = 2,
    Evenings = 3,
}

export class YesNoTag {
    readonly id: number;
    readonly description: string;

    private constructor(id: number, description: string) {
        this.id = id;
        this.description = description;
    }

    public static Yes = new YesNoTag(3302, "yes");
    public static No = new YesNoTag(3303, "no");

    public static asArray = () => [YesNoTag.Yes, YesNoTag.No];

    public static fromId = (id: number) =>
        YesNoTag.asArray().find(t => t.id === id);
}
